import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {UserSummary} from '../../entity/userSummary.model';

@Component({
  selector: 'app-user-avatar',
  templateUrl: './user-avatar.component.html',
})
export class UserAvatarComponent implements OnChanges{

  @Input() user: UserSummary;
  @Input() size = 20;
  @Input() tooltip: string;
  imgSrc = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.user) {
      this.imgSrc = this.user?.picturePublicUrl;
      if (this.imgSrc) {
        this.imgSrc = this.user?.gender?.value === 'M' ? 'assets/images/profile/user-1.jpg' : 'assets/images/profile/user-9.jpg';
      }
    }
  }


}
